module.exports = __webpack_public_path__ + "static/Slaad_blue-38654a94fd4499d1e5adefbe3a6ab456.jpg";